
/**
 * SPA-side workspace footer card rendered in the bottom of the sidebar.
 * Shows the workspace name + environment indicator + a switcher chevron.
 *
 * Previously hard-coded inside @pipebase/ui's Sidebar component. Extracted
 * so the package's Sidebar stays workspace-agnostic — Local Monitor and
 * other non-SPA consumers don't need a workspace concept.
 *
 * The `collapsed` prop comes from the Sidebar via its render-prop `footer`
 * slot so the footer matches the sidebar's compact/expanded state.
 */
export function WorkspaceFooter({ collapsed, name, cloud }: { collapsed: boolean; name: string; cloud: boolean }) {
  // Not a control: there is nothing to switch to from here (the workspace
  // switcher is in the top bar). Until designer 0.7.58 it was a button that
  // did nothing and always said "Pipebase · self-hosted".
  return (
    <div className="org-card" data-testid="workspace-footer">
      <div className="org-card__avatar" aria-hidden="true">
        {(name.trim()[0] ?? 'P').toUpperCase()}
      </div>
      {!collapsed && (
        <div className="org-card__body">
          <div className="org-card__name">{name}</div>
          <div className="org-card__meta">
            <span className="org-card__env-dot" /> {cloud ? 'Pipebase Cloud' : 'self-hosted'}
          </div>
        </div>
      )}
    </div>
  );
}
